import { Table, Thead, Tbody, Tr, Th } from '@components/core-ui/Table/Table';
import { TProps } from './types/TProps';

export const ParamsTable = ({ nameLabel = 'Name', typeLabel = 'Type', children }: TProps) => (
  <Table className="w-full border-collapse text-left text-sm">
    <Thead>
      <Tr className="border-b border-[var(--color-border)] text-xs text-[var(--color-text-muted)]">
        <Th className="w-48 py-2 pr-4 font-semibold">{nameLabel}</Th>
        <Th className="w-40 py-2 pr-4 font-semibold">{typeLabel}</Th>
        <Th className="py-2 font-semibold">Description</Th>
      </Tr>
    </Thead>
    <Tbody>{children}</Tbody>
  </Table>
);
